module.exports = __webpack_public_path__ + "static/img/Ellipsis-1s-200px.13488cd4.svg";